<template>
    <div class="outline" :class="{'closed': isClosed}">
        <div class="open-close" :class="{'closed': isClosed}" @click="toggle()">
            <span v-if="isClosed">
                <i class="fa-solid fa-chevron-right"></i>
            </span>
            <span v-else>
                <i class="fa-solid fa-chevron-left me-2"></i>
                閉じる
            </span>
        </div>
        <div class="sidemenu" :class="{'closed': isClosed}">
            <div
                class="megamenus"
                v-for="menu in menus"
                :key="menu.id"
                :class="{hide: isClosed}"
            >
                <div v-if="!menu.path" class="menu-category">
                    <i v-if="menu.icon" :class="menu.icon" class="me-2"></i>
                    {{ menu.name }}
                </div>
                <div v-else class="menu-items">
                    <router-link
                        v-if="hasPath(menu)"
                        :to="menu.path"
                        class="menu-item"
                        :class="{
                            active: isActive(menu.path),
                        }"
                    >
                        <span class="menu-item-text">
                            {{ menu.name }}
                        </span>
                        <i v-if="isActive(menu.path)" class="fa-solid fa-circle-dot ms-auto"></i>
                    </router-link>
                    <span class="menu-item disabled" v-else>
                        <span class="menu-item-text">
                            {{ menu.name }}
                        </span>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.sidemenu {
    padding: 60px 16px 16px;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    transition: opacity 0.3s ease;
}
/* スクロールバーのスタイリング */
.sidemenu::-webkit-scrollbar {
    width: 6px;
}

.sidemenu::-webkit-scrollbar-track {
    background: transparent;
}

.sidemenu::-webkit-scrollbar-thumb {
    background: #ced4da;
    border-radius: 3px;
}

.sidemenu::-webkit-scrollbar-thumb:hover {
    background: #adb5bd;
}

.megamenus {

}

.megamenus.hide {
    display: none;
}

.menu-category {
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #6c757d;
    padding: 8px 12px;
    margin-bottom: 4px;
    border-bottom: 2px solid #e9ecef;
}

.menu-items {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.menu-item {
    display: flex;
    align-items: center;
    padding: 10px 12px;
    border-radius: 6px;
    text-decoration: none;
    color: #212529;
    font-size: 15px;
    transition: all 0.2s ease;
    position: relative;
}

.menu-item:hover:not(.disabled) {
    background: #e9ecef;
    color: #0d6efd;
    transform: translateX(2px);
}

.menu-item.active {
    background: linear-gradient(135deg, #0d6efd 0%, #0a58ca 100%);
    color: #fff;
    font-weight: 600;
    box-shadow: 0 2px 4px rgba(13, 110, 253, 0.2);
}

.menu-item.active:hover {
    background: linear-gradient(135deg, #0a58ca 0%, #084298 100%);
    transform: translateX(0);
}

.menu-item.disabled {
    color: #adb5bd;
    cursor: not-allowed;
    opacity: 0.6;
}

.menu-item-text {
    flex: 1;
}

.menu-item i.fa-circle-dot {
    font-size: 10px;
    opacity: 0.8;
}

/* アニメーション */
@keyframes slideIn {
    from {
        opacity: 0;
        transform: translateX(-10px);
    }
    to {
        opacity: 1;
        transform: translateX(0);
    }
}

.menu-item {
    animation: slideIn 0.3s ease;
}

/* レスポンシブ対応 */
@media (max-width: 768px) {
    .outline {
        width: 240px;
    }
    
    .outline.closed {
        width: 0;
        border-right: none;
    }
}

.megamenus {
    background-color: #f5f8fa;
}
.menu {
    margin-top: 1rem;
    margin-bottom: 1rem;
}
.font-light {
    color: #444;
    &:hover {
        color: #222;
    }
}
.disabled_color {
    color:#dcdcdc
}
.now-menu {
    width: 260px;
    text-align: center;
    cursor: pointer;
    padding: .5rem;
    background-color: #f5f8fa;
    transition: 0.2s ease;
    &:hover {
        background-color: #eee;
    }
    &.closed {
        width: 34px;
    }
}
.path {
    text-decoration: none;
    padding-top:6px;
    padding-bottom:6px;
    border-radius:30px;
    padding-left: 12px;
    padding-right: 12px;
    display: block;
    &:hover {
        background-color: #eee;
        color: #212529;
    }
}
.outline {
    height: 100vh;
    width: 260px;
    top: 0px;
    left: 0px;
    position: fixed;
    overflow-x: visible;
    overflow-y: visible;
    background-color: #f5f8fa;
    transition: 0.2s ease;
    z-index: 999;
    &.closed {
        width: 34px;
    }
    .open-close {
        width: 260px;
        text-align: center;
        cursor: pointer;
        padding: .5rem;
        background-color: #f5f8fa;
        transition: 0.2s ease;
        &:hover {
            background-color: #eee;
        }
        &.closed {
            width: 34px;
        }
    }
    .sidemenu {
        position: fixed;
        height: 100vh;
        width: 260px;
        overflow-x: auto;
        overflow-y: auto;
        transition: 0.2s ease;
        &.closed {
            width: 34px;
        }
    }
    .hide {
        display: none !important;
    }
}
@media screen and (max-width: 770px) {
    .outline {
        padding-top: 5rem;
    }
}
</style>


<script>
export default {
    data() {
        return {
            menus: [],
            isClosed: false,
        }
    },
    methods: {
        reload() {
            axios.get("/master/menus/lists").then(res => {
                this.menus = res.data;
            }).catch(err => {Alert.err(err)});
        },
        toggle() {
            this.isClosed = !this.isClosed;
            this.$emit("toggle", this.isClosed);
            document.cookie = "sidebar=" + this.isClosed;
        },
        hasPath(v) {
            if (!this.$store.state.user) return false;
            if (this.$store.state.user.is_root) return true;
            if (this.$store.state.user.menus.find((menu) => menu.id == v.id)) return true;
            return false;
        },
        isActive(path) {
            return this.$route.path === path;
        },
    },
    mounted() {
        this.reload();
        if (document.cookie) {
            let cookies = document.cookie.split(/;/);
            for (const cookie of cookies) {
                let pair = cookie.split(/=/);
                if (pair[0].trim() === "sidebar") {
                    this.isClosed = pair[1] === "true";
                    this.$emit("toggle", this.isClosed);
                }
            }
        }
    }
}
</script>
